import { Suspense, lazy, useEffect } from "react";

// Everything after the hero ships as its own chunk so phones can paint the
// first screen sooner. It starts downloading immediately, in parallel.
const Sections = lazy(() => import("./sections"));

const BelowFold = () => {
	// Once the sections exist, honour a #hash in the URL (e.g. a shared #projects link).
	useEffect(() => {
		const { hash } = window.location;
		if (!hash) return undefined;
		const id = setInterval(() => {
			const el = document.querySelector(hash);
			if (el) {
				el.scrollIntoView();
				clearInterval(id);
			}
		}, 100);
		const stop = setTimeout(() => clearInterval(id), 5000);
		return () => {
			clearInterval(id);
			clearTimeout(stop);
		};
	}, []);

	return (
		<Suspense fallback={<div className="min-h-screen" />}>
			<Sections />
		</Suspense>
	);
};

export default BelowFold;
